import React from "react"

//comps
import FormWrapper from "./FormWrapper"

export default function Add() {
  return (
    <div className="container">
      <h1>Create New Data Order</h1>
      <FormWrapper type="add" currentScreen={1} />
    </div>
  )
}
